// import EventBus from '@/plugins/eventbus'
import { stateGetters, stateSetters } from '@/store/store-utils'
import ChatMessage from '@/store/models/chat/ChatMessage'
import { toMentionsArray } from '@/utils/chat'

import socketActions from '@/store/modules/chat/socket-actions'

const defaultState = {
  loading: true,
  room: null,
  input: '',
  isSending: false,
}

export default {
  name: 'chat',
  namespaced: true,
  state: () => defaultState,
  getters: {
    ...stateGetters(defaultState),
    subscribed: (s, g, rS, rootGetters) => rootGetters.namespaces.includes('chat'),
    messages: ({ room }) => ChatMessage.query()
      .orderBy('timestamp', 'desc')
      .where('room', room)
      .orWhere('user', null) // always include broadcasts
      .limit(50)
      .get()
      .reverse(),

  },
  mutations: {
    ...stateSetters(defaultState),
  },
  actions: {
    ...socketActions,
    async getHistory({ commit }, room) {
      if (!room) return

      commit('setLoading', true)

      try {
        const history = await this.$api.chat.history(room)
        if (history.length > 50) history.length = 50

        // NOTE create cuz we re-fetch this anyways when switching rooms
        await ChatMessage.create({
          data: history,
        })
      } finally {
        commit('setLoading', false)
      }
    },
    async send({ commit, getters }, text) {
      if (!text?.length) return

      // no empty messages
      if (/^\s+$/.test(text)) {
        commit('setInput', '')
        return
      }

      const { room } = getters
      if (!room) return

      const mentions = toMentionsArray(text)

      commit('setIsSending', true)

      try {
        await this.$api.chat.send({ text, mentions, room })
        commit('setInput', '')
      } finally {
        commit('setIsSending', false)
      }
    },
  },
}
